<template lang="pug">
  div
    .van-popup__header
      .van-popup__header__title {{ $t('unit.selectFan') }}
      van-icon.van-popup__header__close(name="close" @click="$emit('close')")

    .unit__fans
      van-icon(
        v-for="(fan, key) in speeds"
        :name="'fan' + fan"
        :class="{select: speed === parseInt(key,10)}"
        :key="key"
        @click="setSpeedFan(key)")
</template>

<script>
import { parseNumber } from '@/utils/sanitaze.utils';

export default {
  props: {
    speeds: {
      required: true,
    },
    speed: {
      type: Number,
      required: true,
    },
  },
  methods: {
    setSpeedFan(speed) {
      this.$emit('setFan', parseNumber(speed));
    },
  },
};
</script>
